import { firm } from "./site";

export type PublishedCaseResult = {
  id: string;
  figure: string;
  outcome: string;
  title: string;
  summary: string;
  detail: string;
  sourceUrl: string;
  storyPath?: string;
  storyLabel?: string;
  sourceNote?: string;
};

// First-party published results; amounts are not net proceeds or collection claims.
export const featuredCaseResult: PublishedCaseResult = {
  id: "kent-county-verdict",
  figure: "$27.5 million",
  outcome: "Motorcycle injury jury verdict",
  title: "Holding a distracted driver accountable",
  summary:
    `A driver using a phone app crossed the centerline and struck a rider, whose injuries included a leg amputation. ${firm.displayName} led the trial team in Kent County.`,
  detail: "The jury returned its verdict on May 3, 2024.",
  sourceUrl: "https://www.motorcyclelawyermichigan.com/27-million-motorcycle-injury-verdict/",
  storyPath: "/27-million-motorcycle-injury-verdict/",
  storyLabel: "Read the verdict story",
};

export const additionalCaseResults: PublishedCaseResult[] = [
  {
    id: "couple-settlement",
    figure: "$1.48 million",
    outcome: "Combined settlement",
    title: "A husband and wife. Two serious injuries.",
    summary:
      "Sean Murphy secured a combined pain-and-suffering settlement for a Northern Michigan couple injured when a distracted driver turned into their path.",
    detail:
      "Both required multiple surgeries. The firm reports that the pain-and-suffering portion settled at mediation after depositions. This is the combined amount for the couple.",
    sourceUrl: "https://www.motorcyclelawyermichigan.com/sean-murphy-1-48-million-motorcycle-crash-settlement/",
    storyPath: "/sean-murphy-1-48-million-motorcycle-crash-settlement/",
    storyLabel: "Read the settlement story",
  },
  {
    id: "construction-verdict",
    figure: "$2 million",
    outcome: "Verdict",
    title: "A fatal crash involving road construction",
    summary: "The firm reports a verdict in a death case involving road construction negligence.",
    detail: "",
    sourceUrl: "https://www.motorcyclelawyermichigan.com/",
    sourceNote: "Source: the firm's published homepage results.",
  },
  {
    id: "broken-leg-settlement",
    figure: "$1.5 million",
    outcome: "Settlement",
    title: "A broken leg after a motorcycle crash",
    summary: "The firm reports a settlement for a motorcyclist who suffered a broken leg because of driver negligence.",
    detail: "",
    sourceUrl: "https://www.motorcyclelawyermichigan.com/",
    sourceNote: "Source: the firm's published homepage results.",
  },
  {
    id: "macomb-liability-verdict",
    figure: "60%",
    outcome: "Fault assigned to the van driver",
    title: "A disputed crash. A different verdict.",
    summary:
      "After a liability-only trial in Macomb County, the jury assigned most of the fault to the van driver in a crash initially blamed on the rider.",
    detail:
      "The rider had rear-ended a van that braked for an emergency vehicle. The published story describes the fault verdict; it does not state a dollar amount.",
    sourceUrl: "https://www.motorcyclelawyermichigan.com/we-won-the-impossible-motorcycle-case/",
    storyPath: "/we-won-the-impossible-motorcycle-case/",
    storyLabel: "Read the trial story",
  },
];

export const homepageWins = additionalCaseResults.filter((result) => result.id !== "macomb-liability-verdict");
